subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
  let btn = document.querySelector('.product-form__submit span');
  let prop = document.getElementById('preOrderProp');

  let input = '<input type="hidden" id="preOrderProp" name="properties[preorder]" value="yes">';

  if(window.pre_order[e.data.variant.id] == true && btn) {
    setTimeout(function(){
      btn.innerText = 'Pre order';
    });

    if(!prop) btn.closest('form')?.insertAdjacentHTML('beforeend', input);
  } else {
    if(prop) prop.remove();
  }
});

// Bundle cards ("pair-with-it") all share the page's single section id, so
// the variant Dawn resolves via its section-scoped AJAX fetch (published on
// variant:change) can belong to the wrong product. Resolve the selected
// variant directly from each product's own variants JSON instead, keyed off
// the option values actually checked on that card.
const pairWithItProductCache = {};

function fetchPairWithItProduct(url) {
  return pairWithItProductCache[url] || (pairWithItProductCache[url] = fetch(url + '.js').then(res => res.json()));
}

function resolvePairWithItVariant(productInfoEl) {
  let url = productInfoEl.dataset.url;
  if (!url) return Promise.resolve(null);

  let selected = Array.from(productInfoEl.querySelectorAll('input[type="radio"]:checked, select'))
    .map(el => el.value);

  if (!selected.length) return Promise.resolve(null);

  return fetchPairWithItProduct(url).then(product => {
    return product.variants.find(variant => {
      let options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return options.length === selected.length && options.every((value, index) => value === selected[index]);
    }) || null;
  });
}

function syncPairWithItVariant(productInfoEl) {
  if (!productInfoEl || !productInfoEl.classList.contains('pair-with-it')) return Promise.resolve();

  let handle = productInfoEl.dataset.handle;
  let updates = document.querySelectorAll('.prop-item-' + handle);

  if (!updates.length) return Promise.resolve();

  return resolvePairWithItVariant(productInfoEl).then(variant => {
    if (!variant) return;

    updates.forEach(update => {
      let id = update.querySelector('.product-id');
      if (id) id.value = variant.id;
    });
  });
}

subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
  syncPairWithItVariant(e.data.productInfoEl);
});

document.addEventListener('change', (e) => {
  let productInfoEl = e.target.closest('product-info.pair-with-it');
  if (productInfoEl) syncPairWithItVariant(productInfoEl);
});

function pairWithIt() {
  let pair_with_it = document.querySelector('.pair-products');
  let form = document.querySelector('.product-single__form');

  if(!pair_with_it || !form) return;

  let products = pair_with_it.querySelectorAll('.product-grid > .grid__item');
  let add_to_cart_btn = form.querySelector('.product-form__submit');

  if(!products.length) return;

  function updateSubmitState() {
    let propSize = form.querySelectorAll('.props').length;

    if(propSize > 0) {
      add_to_cart_btn.removeAttribute('disabled');
    } else {
      add_to_cart_btn.setAttribute('disabled', 'disabled');
    }
  }

  products.forEach(product => {
    let checkbox = product.querySelector('.pair-with-it-checkbox input');

    checkbox.addEventListener('input', function() {
      let handle = this.dataset.handle;
      let gridItem = this.closest('.grid__item');

      if(this.checked) {
        let productInfoEl = gridItem.querySelector('product-info.pair-with-it');

        syncPairWithItVariant(productInfoEl).then(() => {
          if (!this.checked) return;
          let props = gridItem.querySelector('.props').cloneNode(true);
          form.append(props);
          updateSubmitState();
        });
      } else {
        form.querySelector('.prop-item-' + handle)?.remove();
        updateSubmitState();
      }
    });
  });

  const quantityWrappers = document.querySelectorAll('.pair_with_it-quantity');

  quantityWrappers.forEach(wrapper => {
    const input = wrapper.querySelector('.quantity__input');
    const buttons = wrapper.querySelectorAll('.quantity-btn');

    if (!input || !buttons.length) return;

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {

        const wrapperEl = this.closest('[data-handle]');
        if (!wrapperEl) return;

        const handle = wrapperEl.dataset.handle;
        const props = pair_with_it.querySelectorAll('.prop-item-' + handle);

        const action = this.dataset.action;
        const min = parseInt(input.getAttribute('min')) || 1;
        const max = parseInt(input.getAttribute('max'));
        let value = parseInt(input.value) || min;

        if (action === 'plus') {
          if (!max || value < max) value++;
        }

        if (action === 'minus') {
          if (value > min) value--;
        }

        input.value = value;

        props.forEach(prop => {
          const qty = prop.querySelector('.quantity');
          if (qty) qty.value = value;
        });

      });
    });
  });
}

document.addEventListener('DOMContentLoaded', pairWithIt);
